import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import confettiAnimation from 'src/editor/content-creation/native-e-signature/lottie-confetti.json';

interface ConfettiProps {
  isVisible: boolean;
  onComplete?: () => void;
}

const Confetti: React.FC<ConfettiProps> = ({ isVisible, onComplete }) => {
  const [shouldPlay, setShouldPlay] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldPlay(true);
    }
  }, [isVisible]);

  const defaultOptions = {
    loop: false,
    autoplay: shouldPlay,
    animationData: confettiAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const handleAnimationComplete = () => {
    setShouldPlay(false);
    onComplete?.();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] pointer-events-none flex items-center justify-center">
      <div className="w-full h-full flex items-center justify-center">
        <Lottie
          options={defaultOptions}
          height="100%"
          width="100%"
          eventListeners={[
            {
              eventName: 'complete',
              callback: handleAnimationComplete
            }
          ]}
        />
      </div>
    </div>
  );
};

export default Confetti;
